import { useMemo } from 'react'
import isEmpty from 'lodash/isEmpty'

function useAuthority(userAuthority = [], authority = [], emptyCheck = false) {

    const roleMatched = useMemo(() => {
		return authority.some(role => userAuthority.includes(role))
	}, [authority, userAuthority])

    // A route/element that declares no required authority is open to any
    // authenticated user. NOTE: an empty `userAuthority` must NOT short-circuit
    // to "allowed" — a user with no (or no matching) role must be denied on a
    // role-gated route. (Previously `isEmpty(userAuthority)` granted access to
    // everyone, making RBAC a no-op.)
    if (isEmpty(authority) || typeof authority === 'undefined') {
		return !emptyCheck
	}

    return roleMatched
}

export default useAuthority

